module.exports = __webpack_public_path__ + "static/profile-06996a14465472790da940a70cbcb0fc.jpeg";